import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import { useTracker } from '../tracking/useTracker';
import { StyledUILink } from './TextInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipWrapper = styled.div.withConfig({
  displayName: "TooltipText__TooltipWrapper",
  componentId: "sc-15vmm86-0"
})(["", ""], props => props.$isMobile && `padding: 10px 0; `);
export const TooltipText = ({
  tooltipLink,
  stepKey,
  isMobile
}) => {
  const Tracker = useTracker();
  return /*#__PURE__*/_jsx(TooltipWrapper, {
    $isMobile: isMobile,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `views.${stepKey}.tooltip`,
      options: {
        link: /*#__PURE__*/_jsx(StyledUILink, {
          external: true,
          href: tooltipLink,
          onClick: event => {
            event.preventDefault();
            Tracker.signupInteraction('click-tooltip-link');
            window.open(tooltipLink, '_blank');
          },
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `views.${stepKey}.tooltipLink`
          })
        }, "title-link")
      }
    })
  });
};
export default TooltipText;